import { SwiftFoxEvent } from '../events/contracts';

export function getEventType(event: SwiftFoxEvent) {
	if (!event) return '';

	return event.location?.formatted
		? event.meetingUrl || event.zoomId
			? LocationFilterOptions.HYBRID
			: LocationFilterOptions.IN_PERSON
		: event.meetingUrl || event.zoomId
		? LocationFilterOptions.ONLINE
		: 'TBD';
}

export const DateFilterOptions = {
	TODAY: 'Today',
	THIS_WEEK: 'This week',
	NEXT_WEEK: 'Next week',
	THIS_MONTH: 'This month',
	LAST_WEEK: 'Last week',
	ALL_PAST: 'All past',
	ALL_UPCOMING: 'All upcoming',
	ALL_EVENTS: 'All events'
};

export const LocationFilterOptions = {
	ONLINE: 'Online',
	HYBRID: 'Hybrid',
	IN_PERSON: 'In person'
};

export const StateFilterOptions = {
	VIC: 'Victoria',
	NSW: 'New South Wales',
	NT: 'Northern Territory',
	QLD: 'Queensland',
	SA: 'South Australia',
	WA: 'Western Australia',
	ACT: 'Australian Capital Territory',
	TAS: 'Tasmania'
};

export enum DEFAULT_RSVP_ID {
	attending = 'attending',
	notAttending = 'not_attending',
	attended = 'attended',
	didNotAttend = 'did_not_attend',
	onWaitlist = 'on_waitlist'
}
